// extracted by mini-css-extract-plugin
module.exports = {"alertBox":"AlertBox_alertBox__10Ufe"};